import styled from "styled-components";

export function About() {
  return (
    <Container>
      {/* descrição inicial */}
      <Subcontainer>
        <Title>
          Guilherme Ytalo
          <br />
        </Title>
        {/* cover letter */}
        <Cover>
          Atualmente trabalhando com Ionic e Angular e aspirante a React
          <br />
          React Native, curioso por tecnologias híbridas e design no front em
          geral.
        </Cover>
      </Subcontainer>
    </Container>
  );
}

const Container = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const Subcontainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  text-align: center;
`;

const Title = styled.h1`
  color: #fff;
  margin-top: 0;
  font-size: 4em;
`;

const Cover = styled.p`
  color: #fff;
  margin: 0;
`;
